export const faqs = [
  {
    question: 'What is a relationship counter?',
    answer: 'A relationship counter shows the time since your relationship began. Amevo tracks that time continuously and connects it with your anniversaries, milestones and shared statistics.',
  },
  {
    question: 'Can Amevo remind me about anniversaries?',
    answer: 'Yes. You can set local reminders for anniversaries, milestones and custom special days. Notifications are scheduled on your device according to the settings you choose.',
  },
  {
    question: 'Does Amevo require an account?',
    answer: 'No. You can use Amevo without creating an account or providing an email address or password.',
  },
  {
    question: 'Where is my relationship data stored?',
    answer: 'Names, dates, milestones, photos and settings you enter are stored locally on your device. Amevo does not keep a server-side copy of your relationship content.',
  },
  {
    question: 'Is Amevo available on iPhone and Android?',
    answer: 'Yes. Amevo is available from both the Apple App Store and Google Play.',
  },
];
